import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"lock\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.209 8.02a3.437 3.437 0 1 0-6.875 0v2.238a2.25 2.25 0 0 0-1.376 2.074v2.375a2.25 2.25 0 0 0 2.25 2.25h5.124a2.25 2.25 0 0 0 2.25-2.25v-2.375a2.25 2.25 0 0 0-1.373-2.073v-2.24Zm-1.375 2.062V8.02a2.062 2.062 0 1 0-4.125 0v2.062h4.125Zm-2.752 2.75a.687.687 0 1 1 1.375 0v1.375a.687.687 0 1 1-1.375 0v-1.375Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol